import packageJson from '../../package.json';

export const environment = {
  apiUrl: 'https://fb-dlms.aakil.net',
  metabaseApiUrl: 'https://fb-dlms.aakil.net/loan/api/metabase',
  apiDocUrl: 'https://fb-dlms.aakil.net',
  apiBioUrl: 'https://fb-dlms.aakil.net',
  mcpApiUrl: 'https://fb-dlms.aakil.net/mcp',
  mcpNotificationsEnabled: true,
  keycloakHost: 'https://fb-dkc.aakil.net',
  keycloak: {
    // Url of the Identity Provider
    issuer: 'https://fb-dkc.aakil.net/auth/realms/LMS',

    // URL of the SPA to redirect the user to after login
    redirectUri: 'https://fb-dlms.aakil.net/',

    // URL of the SPA to redirect the user after silent refresh
    silentRefreshRedirectUri: window.location.origin + '/assets/silent-check-sso.html',

    // defaults to true for implicit flow and false for code flow
    // as for code code the default is using a refresh_token
    // Also see docs section 'Token Refresh'
    useSilentRefresh: true,

    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'web_app',

    oidc: true,
    responseType: 'code',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC.
    scope: 'openid profile email offline_access',
    // Remove the requirement of using Https to simplify the demo
    // THIS SHOULD NOT BE USED IN PRODUCTION
    // USE A CERTIFICATE FOR YOUR IDP
    // IN PRODUCTION
    requireHttps: true,
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true,

    // at_hash is not present in JWT token
    showDebugInformation: true,
    disableAtHashCheck: true,
  },
  enableDebug: true,
  serviceWorker: true,
  production: false,
  showtrace: true,
  dummy_JSONs: false,
  showClientNotes: false,
  enableNewLandingLayout: true,
  name: 'DEV',
  version: packageJson.version,
  useMdb5Adapted: true,
  showTribute: true
};
